<template>
  <b-modal
    hide-footer
    id="modal-doc-history"
    ref="modal-doc-history"
    size="lg"
    title="ประวัติสถานะ"
  >
    <b-row v-if="docHistoryDetail.length > 0">
      <b-col
        v-for="item in docHistoryDetail"
        :key="item.documentTracking.docTrackingId"
        cols="12"
        class="list-group list-group-circle text-left m-1"
      >
        <div class="d-flex list-group-item">
          <div class="">
            <h5 class="mb-0">
              {{ item.documentTracking.createDateStr }} -
              {{ item.tmMaster.description }}
            </h5>
            <!-- <small class="text-muted">{{ item.createTracking }}</small> -->
          </div>
          <div class="col ml-auto">
            <hr class="my-12 bg-dark" />
          </div>
        </div>

        <div class="d-flex justify-content-between mb-1">
          <span class="mb-0">
            ดำเนินการโดย {{ item.users.titleStr }} {{ item.users.fName }}
            {{ item.users.lName }}
          </span>
          <small class="mb-0"></small>
        </div>

        <div class="d-flex justify-content-between ml-1">
          <span>
            ความคิดเห็น:
            {{
              item.documentTracking.comment == null ||
              item.documentTracking.comment == ""
                ? "-"
                : item.documentTracking.comment
            }}
          </span>
        </div>

        <div
          class="d-flex justify-content-between ml-1"
          v-if="item.documentTracking.fileName != null"
        >
          <span>
            <a
              :href="item.documentTracking.filePath"
              :download="item.documentTracking.fileName"
              target="_blank"
            >
              <b-icon icon="star-fill" animation="fade" font-scale="4"></b-icon>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24px"
                height="24px"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="feather feather-arrow-down-circle"
              >
                <circle cx="12" cy="12" r="10" />
                <polyline points="8 12 12 16 16 12" />
                <line x1="12" y1="8" x2="12" y2="16" />
              </svg>
              {{ item.documentTracking.fileName }}
            </a>
          </span>
        </div>
      </b-col>
    </b-row>
    <b-row v-if="docHistoryDetail.length > 0">
      <b-col>
        <div class="d-flex justify-content-between ml-1 mt-1 text-center">
          <span>
            <b-button
              variant="outline-primary"
              @click="getSuccess(docHistoryDetail[0].documentTracking.docId)"
            >
              ดูเอกสารคำขอ
            </b-button>
          </span>
        </div>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BModal,
  BButton,
  BFormTextarea,
  BCard,
} from "bootstrap-vue";

import appsettings from "@/store/app-settings";
import * as userData from "@/auth/localStorageUtils.js";

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BButton,
    BModal,
    BFormTextarea,
    BCard,
  },
  props: {
    docHistoryDetail: [],
  },
  data() {
    return {};
  },
  created() {
    console.log(this.docHistoryDetail);
  },
  mounted() {
    //console.log("modal mounted");
  },
  methods: {
    getSuccess(docId) {
      // let redirectUrl =
      //   location.origin + this.$router.resolve({ name: "Approve" }).href;
      // let redirectBack =
      //   location.origin + this.$router.resolve({ name: "Approve" }).href;

      let redirectUrl = location.origin + this.$router.currentRoute.fullPath;

      const documentUrl = appsettings.documentUrl
        .replace("{0}", docId)
        .replace("{1}", userData.userId())
        .replace("{2}", redirectUrl)
        .replace("{3}", redirectUrl);

      //window.location.href = documentUrl;

      window.open(documentUrl, "_blank");
    },
  },
};
</script>

<style></style>
